import { render, staticRenderFns } from "./new_idea_modal.vue?vue&type=template&id=35bd4edf&scoped=true&"
import script from "./new_idea_modal.vue?vue&type=script&lang=js&"
export * from "./new_idea_modal.vue?vue&type=script&lang=js&"
import style0 from "./new_idea_modal.vue?vue&type=style&index=0&id=35bd4edf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bd4edf",
  null
  
)

export default component.exports